import React from 'react';

// Read-only stars row used by ReviewItem. Renders N filled images
// using the same /_core/assets/themes/bidding/assets/images/star1.svg the legacy template used (CSS
// in redesign.css paints them at the correct size). Empty slots
// stay omitted — legacy markup did the same (filled-only output).
export function StarsDisplay({rate}) {
    const filled = Math.max(0, Math.min(5, Math.round(Number(rate) || 0)));
    return (
        <div className="testimonials-item__stars">
            {Array.from({length: filled}, (_, i) => (
                <img key={i} src="/_core/assets/themes/bidding/assets/images/star1.svg" alt="rating star"/>
            ))}
        </div>
    );
}

// Interactive 5-star picker for the form. Markup mirrors the legacy
// `.testimonial-form__chack-rate > .rate-item.one|two|three|four|five`
// pattern. `active` class is what legacy CSS (redesign.css) actually
// keys off to swap the empty-star.svg background for star1.svg.
const POSITIONS = ['one', 'two', 'three', 'four', 'five'];

export function StarsPicker({value, onChange}) {
    return (
        <div className="testimonial-form__chack-rate">
            {POSITIONS.map((pos, idx) => {
                const stars = idx + 1;
                const active = stars <= value;
                return (
                    <span
                        key={pos}
                        role="button"
                        tabIndex={0}
                        aria-label={`${stars} star${stars > 1 ? 's' : ''}`}
                        className={`rate-item ${pos}${active ? ' active' : ''}`}
                        data-value={stars}
                        style={{cursor: 'pointer'}}
                        onClick={() => onChange(stars)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onChange(stars);
                            }
                        }}
                    />
                );
            })}
            <input type="hidden" name="rate" value={String(value)} readOnly/>
        </div>
    );
}
